export const visitEventFlow = function* (ctx, visitorStep) {
  if (visitorStep.type !== 'eventFlow') return;
  const flow = visitorStep.value;
  for (let stepIndex = 0; stepIndex < flow.steps.length; stepIndex++) {
    const step = flow.steps[stepIndex];
    if (!step) continue;
    yield {
      type: 'eventFlowStep',
      place: ['steps', stepIndex],
      description: `事件行为的第${stepIndex}步`
    };
  }
};
//# sourceMappingURL=visitEventFlow.js.map
